import React from 'react';
import { Card, CardContent } from './ui/card';
import { Leaf, Recycle, Home, ThermometerSnowflake, Droplets, TreePine } from 'lucide-react';

const EcoPositioning = () => {
  const ecoValues = [
    {
      icon: Leaf,
      title: 'Enduits traditionnels à la chaux',
      description: 'Matériaux naturels compatibles avec le fonctionnement des murs anciens'
    },
    {
      icon: TreePine,
      title: 'Isolation biosourcée fibre de bois',
      description: 'Isolants biosourcés (fibre de bois, chanvre, liège) performants pour l\'ITE et l\'ITI'
    },
    {
      icon: Home,
      title: 'Isolation intérieure biosourcée',
      description: 'Matériaux respirants adaptés au bâti ancien et moderne'
    },
    {
      icon: ThermometerSnowflake,
      title: 'Corrections ponts thermiques',
      description: 'Traitement des points faibles pour optimiser la performance'
    },
    {
      icon: Droplets,
      title: 'Finitions minérales respirantes',
      description: 'Enduits et peintures permettant la régulation hygrométrique'
    },
    {
      icon: Recycle,
      title: 'Solutions à faible impact carbone',
      description: 'Matériaux écologiques pour une rénovation responsable'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Matériaux &amp; savoir-faire
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Des matériaux étudiés, naturels et biosourcés
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed">
            Selon votre projet et votre bâti, VIREO peut mettre en œuvre des <strong>matériaux naturels et biosourcés</strong> — chaux, fibre de bois, chanvre, finitions minérales — compatibles avec le fonctionnement des murs anciens et performants pour la rénovation énergétique. Un savoir-faire au service de la qualité, pas une contrainte.
          </p>
        </div>

        {/* Eco Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {ecoValues.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <Card 
                key={index}
                className="border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 bg-white group"
              >
                <CardContent className="pt-8 pb-8">
                  <div className="flex flex-col items-center text-center">
                    <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mb-5 group-hover:bg-gradient-to-br group-hover:from-emerald-600 group-hover:to-cyan-600 transition-all duration-300">
                      <IconComponent className="h-8 w-8 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-900 mb-3">
                      {value.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Mission Statement */}
        <div className="max-w-4xl mx-auto">
          <Card data-testid="eco-mission-card" className="bg-gradient-to-br from-emerald-50 to-cyan-50 border-emerald-200">
            <CardContent className="py-8 px-8">
              <p className="text-lg text-slate-700 text-center leading-relaxed">
                <span className="font-semibold text-emerald-800">Notre objectif :</span> améliorer la performance énergétique des bâtiments avec des <strong>matériaux biosourcés</strong>, tout en respectant leur équilibre hygrothermique et leur valeur patrimoniale. La rénovation durable et responsable est inscrite dans notre identité.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default EcoPositioning;
